import React, { useEffect, useState } from 'react';
import postService from '../../../services/community/postService';
import usePosts from '../../../hooks/community/usePosts';
import EmptyScreenView from '../../components/misc/EmptyScreenView';
// eslint-disable-next-line import/extensions
import PostsWall from '../../components/posts/PostsWall';
// eslint-disable-next-line import/extensions
import CreateEditPostModal from '../../components/modals/CreateEditPostModal';
import { Post } from '../../../types/post';

interface PostsTabProps {
  createModalOpen: boolean;
  setCreateModalOpen: (open: boolean) => void;
}

export default function PostsTab({ createModalOpen, setCreateModalOpen }: PostsTabProps): JSX.Element {
  const posts = usePosts();
  const [editingPost, setEditingPost] = useState<Post | undefined>();

  useEffect(() => {
    postService.getPosts();
  }, []);

  const modalOpen = createModalOpen || !!editingPost;
  const handleCloseModal = () => {
    setCreateModalOpen(false);
    setEditingPost(undefined);
  };

  const handleEdit = (post: Post) => {
    setEditingPost(post);
  };

  const hasData = posts !== null && posts.length > 0;

  return (
    <>
      {hasData ? (
        <PostsWall onEdit={handleEdit} />
      ) : (
        <EmptyScreenView />
      )}
      <CreateEditPostModal
        open={modalOpen}
        setOpen={(open) => {
          if (!open) handleCloseModal();
        }}
        post={editingPost}
        onSuccess={() => {
          handleCloseModal();
          postService.getPosts();
        }}
      />
    </>
  );
}
